export default "__VITE_PUBLIC_ASSET__cd9e4e4c__"